import React from 'react';

interface LiveToggleSwitchProps {
  isLive: boolean;
  onToggle: (newState: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
  label?: string;
  showLabel?: boolean;
}

export function LiveToggleSwitch({ isLive, onToggle, disabled = false, size = 'md', label, showLabel = true }: LiveToggleSwitchProps) {
  const isSm = size === 'sm';
  const trackW = isSm ? 'w-8' : 'w-11';
  const trackH = isSm ? 'h-[18px]' : 'h-6';
  const thumbSize = isSm ? 'w-3.5 h-3.5' : 'w-5 h-5';
  const thumbTranslate = isLive ? (isSm ? 'translate-x-[14px]' : 'translate-x-[22px]') : 'translate-x-0';

  return (
    <div className="flex items-center gap-2">
      {showLabel && (
        <span className={`text-xs font-bold ${isLive ? 'text-emerald-700' : 'text-slate-500'}`}>
          {label ?? (isLive ? 'LIVE' : 'DRAFT')}
        </span>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={isLive}
        aria-label={label ?? 'Public Menu Status'}
        disabled={disabled}
        onClick={() => onToggle(!isLive)}
        className={`
          relative inline-flex ${trackW} ${trackH} items-center rounded-full
          transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          ${isLive
            ? 'bg-emerald-500 focus-visible:ring-emerald-400'
            : 'bg-slate-300 focus-visible:ring-slate-400'
          }
        `}
      >
        <span
          className={`
            inline-block ${thumbSize} rounded-full bg-white shadow-sm
            transform transition-transform duration-200 ease-in-out
            ${thumbTranslate}
            ${isSm ? 'ml-0.5' : 'ml-[2px]'}
          `}
        />
      </button>
    </div>
  );
}
